import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { LangProvider } from "./i18n";
import { Navbar } from "./components/Navbar";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import AuthPage from "./pages/AuthPage";
import LinkChannel from "./pages/LinkChannel";
import StreamerDashboard from "./pages/StreamerDashboard";
import FanDashboard from "./pages/FanDashboard";
import Discover from "./pages/Discover";
import StreamerProfile from "./pages/StreamerProfile";
import PaymentSuccess from "./pages/PaymentSuccess";
import PaymentCancel from "./pages/PaymentCancel";
import AdminPanel from "./pages/AdminPanel";
import Terms from "./pages/Terms";
import Privacy from "./pages/Privacy";
import Contact from "./pages/Contact";
import Debates from "./pages/Debates";
import AuthCallback from "./pages/AuthCallback";
import TimerOverlay from "./pages/TimerOverlay";
import { CookieBanner } from "./components/CookieBanner";
import { ChatWidget } from "./components/ChatWidget";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-16 text-center text-zinc-500">...</div>;
  if (user === false) return <Navigate to="/auth" replace />;
  return children;
};

const AdminRoute = ({ children }) => {
  const { user } = useAuth();
  if (user === null) return <div className="p-16 text-center text-zinc-500">...</div>;
  if (user === false) return <Navigate to="/auth" replace />;
  if (user.role !== "admin") return <Navigate to="/" replace />;
  return children;
};

const Dashboard = () => {
  const { user } = useAuth();
  if (user === null) return <div className="p-16 text-center text-zinc-500">...</div>;
  if (user === false) return <Navigate to="/auth" replace />;
  if (user.role === "admin") return <Navigate to="/admin" replace />;
  return user.role === "streamer" ? <StreamerDashboard /> : <FanDashboard />;
};

const AppRoutes = () => {
  const location = useLocation();
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/auth" element={<AuthPage />} />
      <Route path="/descubrir" element={<Discover />} />
      <Route path="/debates" element={<Debates />} />
      <Route path="/streamer/:id" element={<StreamerProfile />} />
      <Route path="/dashboard" element={<Dashboard />} />
      <Route path="/vincular" element={<Protected><LinkChannel /></Protected>} />
      <Route path="/admin" element={<AdminRoute><AdminPanel /></AdminRoute>} />
      <Route path="/payment/success" element={<PaymentSuccess />} />
      <Route path="/payment/cancel" element={<PaymentCancel />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

const Shell = () => {
  const location = useLocation();
  if (location.pathname.startsWith("/overlay")) {
    return (
      <Routes>
        <Route path="/overlay/timer/:id" element={<TimerOverlay />} />
      </Routes>
    );
  }
  return (
    <>
      <Navbar />
      <AppRoutes />
      <CookieBanner />
      <ChatWidget />
    </>
  );
};

function App() {
  return (
    <div className="App bg-zinc-950 min-h-screen">
      <LangProvider>
        <AuthProvider>
          <BrowserRouter>
            <Shell />
            <Toaster position="top-right" richColors theme="dark" offset={80} />
          </BrowserRouter>
        </AuthProvider>
      </LangProvider>
    </div>
  );
}

export default App;
